import React from 'react';
import styled from 'styled-components';

import { Form, Radio, Input, Tooltip } from 'antd';

import { useImmerAtom } from 'jotai-immer';
import * as Constants from '../../views/diagnosis/constants';
import { diabetesAtom, diabetesStatusChangeAtom } from './atom';
import { useHandleEventValue } from './hooks';

import PregnantStatus from './DiabetesPregnantStatus';
import { useSetAtom } from 'jotai';

export default function Index({ getFieldDecorator, radioButtonMessage, inputMessage, color }) {
  const [, setDiabetes] = useImmerAtom(diabetesAtom);
  const handleChangeValue = useHandleEventValue({ setImmerState: setDiabetes });
  const handleDiabetesStatusChangeValue = useSetAtom(diabetesStatusChangeAtom);
  return (
    <>
      <Form.Item>
        {getFieldDecorator('diabetesStatus', {
          initialValue: '',
          rules: [
            {
              required: true,
              message: radioButtonMessage
            }
          ]
        })(
          <CheckDiagnosisSection>
            <QueryTitle>진단받은 당뇨 유형을 선택해주세요</QueryTitle>
            <Radio.Group buttonStyle="solid">
              {Constants.DIABETES_STATUS.map(item => {
                const { name, value } = item;
                return (
                  <SelectBox key={value} onClick={() => handleDiabetesStatusChangeValue(value)} value={value}>
                    {name}
                  </SelectBox>
                );
              })}
            </Radio.Group>
          </CheckDiagnosisSection>
        )}
      </Form.Item>
      <PregnantStatus getFieldDecorator={getFieldDecorator} radioButtonMessage={radioButtonMessage} />
      <Form.Item>
        {getFieldDecorator('fbs', {
          rules: [
            {
              required: true,
              message: inputMessage
            },
            {
              max: 3,
              message: '2~3자리 숫자를 입력해주세요. (예:80)'
            }
          ]
        })(
          <HeightSection>
            <FbsTitle>혈당을 입력해주세요</FbsTitle>
            <FbsSubTitle>수치를 입력하시면, 더 자세한 영양상담이 가능합니다.</FbsSubTitle>
            <SubQueryTitle>공복혈당 (필수사항)</SubQueryTitle>
            <InputBox name="fbs" onChange={handleChangeValue('fbs')} placeholder="예: 80" suffix="mg/dL" maxLength={3} type="number" />
          </HeightSection>
        )}
      </Form.Item>
      <Form.Item>
        {getFieldDecorator('twoHrPg', {
          rules: [
            {
              required: false,
              message: inputMessage
            },
            {
              max: 3,
              message: '2~3자리 숫자를 입력해주세요. (예:80)'
            }
          ]
        })(
          <HeightSection>
            <SubQueryTitle>식후 2시간 뒤 혈당</SubQueryTitle>
            <InputBox name="twoHrPg" onChange={handleChangeValue('twoHrPg')} placeholder="예: 80" suffix="mg/dL" maxLength={3} type="number" />
          </HeightSection>
        )}
      </Form.Item>
      <Form.Item>
        {getFieldDecorator('glycosylatedHemoglobin', {
          rules: [
            {
              required: false,
              message: inputMessage
            },
            {
              maxLength: 3,
              message: '2~3자리 숫자를 입력해주세요. (예:5.7)'
            }
          ]
        })(
          <>
            <HeightSection>
              <SubQueryTitle>
                당화혈색소
                <br />
              </SubQueryTitle>
              <InputBox name="glycosylatedHemoglobin" onChange={handleChangeValue('glycosylatedHemoglobin')} placeholder="예: 5.7" suffix="%" maxLength={3} type="number" />
            </HeightSection>
            <Tooltip
              placement="bottom"
              title="최근 2-3개월의 평균 혈당치로 
            조절 상태를 파악할 수 있는 지표"
            >
              <span style={{ color }}>당화혈색소란?</span>
            </Tooltip>
          </>
        )}
      </Form.Item>
    </>
  );
}
const RelayionTypeSection = styled.div`
  .ant-radio-group {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
  }
  .ant-input-affix-wrapper .ant-input:not(:last-child) {
    font-size: 1.8rem;
    ${props => props.theme.device.md} {
      font-size: 2.4rem;
    }
  }
`;
const CheckDiagnosisSection = styled(RelayionTypeSection)``;

const QueryTitle = styled.div`
  word-break: keep-all;
  font-size: 2.1rem;
  font-weight: 700;
  color: #323232;
  margin-bottom: 2rem;
  margin-top: 5rem;
  ${props => props.theme.device.md} {
    margin-top: 10rem;
    font-size: 2.9rem;
  }
`;

const SubQueryTitle = styled.div`
  word-break: keep-all;
  font-size: 1.8rem;
  font-weight: 400;
  color: #323232;
  margin-bottom: ${props => (props.isText ? '0' : '2rem')};

  ${props => props.theme.device.md} {
    font-size: 2rem;
  }
`;
const FbsTitle = styled(QueryTitle)`
  margin-bottom: 0rem;
`;

const FbsSubTitle = styled.div`
  color: gray;
  margin-bottom: 3rem;
  ${props => props.theme.device.md} {
    font-size: 2rem;
  }
`;
const SelectBox = styled(Radio.Button)`
  height: 6rem;
  word-break: keep-all;
  margin: 0.5rem 0;
  width: calc(50% - 1.6rem);
  line-height: ${props => (props.lineHight ? '4rem' : '6rem')};
  span {
    font-size: 1.6rem;
  }
  ${props => props.theme.device.md} {
    height: 7.2rem;
    line-height: ${props => (props.lineHight ? '6.5rem' : '7.2rem')};
    span {
      font-size: 2.4rem;
      word-break: keep-all;
    }
  }
`;
const HeightSection = styled(RelayionTypeSection)``;
const InputBox = styled(Input)`
  width: 60%;
  height: 6rem;
  line-height: 6rem;
  font-size: 1.8rem;
  margin-bottom: 1rem;
  input::placeholder {
    font-size: 1.8rem;
  }
  ${props => props.theme.device.md} {
    font-size: 2.4rem;
    height: 7.2rem;
    line-height: 7.2rem;
    input::placeholder {
      font-size: 2.4rem;
    }
  }
`;
